var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-documents-status-and-send-date"},[_c('e-documents-status',{attrs:{"value":_vm.value}}),(_vm.item.scheduledAt)?_c('block-document-send-date',{attrs:{"scheduled-date":_vm.item.scheduledAt}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }